import {
  LOGINBYUSER,
} from '../actions/login';
import {reducerPackage} from "../../utils";

export const loginUser = reducerPackage(LOGINBYUSER);
